$(function () {  
	$("body").on("keydown", "#lnkAccountSummary", function(e){
		if(e.which == 13){ //enter key
			e.preventDefault();
			if( $(".accountsummary_view").is(":visible")){
				hideAccountView();
			}else{ 
				showAccountView(); 
				$(this).parent().find(".accountsummary_items").find("li").first().find("a").focus();
			}
		}
	});
	
	$("body").on("keydown", ".accountsummary_items li a", function(e){
		if(e.which == 40){ //down arrow
			e.preventDefault();
	 		if($(".accountsummary_items li").last().find("a").is(":focus")){
	 			  $("#lnkAccountSummary").focus();
	 			  hideAccountView();
	 		}else{
	 			$(this).parent("li").next("li").find("a").focus();
	 		}
	 	} else if (e.which == 38){ //up arrow
	 		e.preventDefault();
	 		if($(".accountsummary_items li").first().find("a").is(":focus")){
	 			 $("#lnkAccountSummary").focus();
	 			 hideAccountView();
	 		}else{
	 			$(this).parent("li").prev("li").find("a").focus();
	 		}
	 	} else if (e.which == 9){ //tab
	 		e.preventDefault();
	 		if($(".accountsummary_items li").last().find("a").is(":focus")){
	 			$("#lnkAccountSummary").focus();
	 			hideAccountView();
	 		}
	 		else {
	 			$(this).parent("li").next("li").find("a").focus();
	 		}
	 	}
	 });
	 
	 $("body").on("keydown", "#lnkCartSummary", function(e){
	 	if(e.which == 13){ //enter key
	 		e.preventDefault();
		 	if($(".cartsummary_view").is(":visible")){
		 		hideCartView(); 
		 	}else{ 
		 		showCartView();
		 		$(".cartsummary_view").focus();
		 	}
		 }
	 });

	$("body").on("keydown", ".cartsummary_buttons", function(e){
	 	if(e.which == 40 || e.which == 38){ //down arrow, up arrow
	 		e.preventDefault();
			hideCartView(); 
			$("#lnkCartSummary").focus();
	 	}
	 });
	 
	 $("body").on("blur", "#checkoutLink", function(){
		hideCartView(); 
		$("#lnkCartSummary").focus();
	});  
	
});